import createFormValues from './createFormValues';
import plain from './structure/plain';
export default createFormValues(plain);


//////////////////
// WEBPACK FOOTER
// /home/circleci/pickle/~/redux-form/es/formValues.js
// module id = 7q89
// module chunks = 1